module.exports = __webpack_public_path__ + "static/img/Q22025CrmUsed.cf437c5.jpg";